import { ChangeEvent } from "react";
import { Box, Typography } from "@mui/material";
import { UploadFileIcon } from "~components/Icons";

interface Props {
  onFileChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

const Default = ({ onFileChange }: Props) => (
  <>
    <UploadFileIcon />
    <Box sx={{ ml: "25px", textAlign: "center" }}>
      <Typography sx={{ fontSize: "16px" }}>
        selecione um arquivo excel
      </Typography>
      <Typography sx={{ fontSize: "10px" }}>
        o arquivo deve ser .xlsx, com as colunas obrigatórias "id_produto" ou "id" (apenas números) e "categoria"
      </Typography>
    </Box>
    <input onChange={onFileChange} type="file" accept=".xlsx" hidden />
  </>
);

export default Default;
